import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import {
  FlexRowCenter,
  FlexColCenterVertical,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { DsiCheckBox as CheckBox } from '../../General/Checkbox';
// @ts-ignore
// import * as mastercard from '../../../../../assets/dsi/payments/mastercard-logo.svg';
// import * as visa from '../../../../../assets/dsi/payments/visa.svg';
// import * as cofidis from '../../../../../assets/dsi/payments/cofidis.svg';
// import * as skippay from '../../../../../assets/dsi/payments/skippay_mallpay.svg';
// import * as twisto from '../../../../../assets/dsi/payments/twisto.svg';
// import * as platim_pak from '../../../../../assets/dsi/payments/platim_pak.svg';
// import * as applepay from '../../../../../assets/dsi/payments/apple-pay.svg';
// import * as googlepay from '../../../../../assets/dsi/payments/google-pay.svg';

export enum Delivery {
  ZASIELKOVNA = 'ZASIELKOVNA',
}

const Wrapper: any = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  /* height: ${rem(56)}; */
  border-radius: ${rem(2)};
  margin-bottom: ${rem(8)};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};

  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    cursor: pointer;
  }
`;

const RowWrapper = styled(FlexRowCenter)`
  width: 100%;

  ${({ theme }) => theme.mediab.l925`
    height: ${rem(85)};
    display: flex;
    align-items: center;
  `}
`;

const PriceWrapper = styled(FlexRowCenter)`
  margin-left: auto;
  justify-content: flex-start;
  padding: ${rem(16)} ${rem(24)};

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
  `}
`;

const Price = styled(TextP)`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 400;
`;

const NamePriceWrapper = styled(FlexRowCenterVertical)`
  display: flex;
  flex-flow: wrap;
  width: 100%;
  padding: ${rem(16)} ${rem(24)};
`;

const Desc = styled.p`
  margin-bottom: 0;
  margin-top: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: ${rem(16)} ${rem(24)};
`;
const ImageContainer = styled.div`
  height: 100%;
`;

const Image = styled.img`
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  max-height: 13px;
  margin-left: 12px;
  width: 100%;
`;

const ComgateImage = styled.img`
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  max-height: 23px;
  margin-left: 12px;
  width: 100%;
`;

const ImagesContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const ImagesContainerComgateCustom = styled(ImagesContainer)`
  ${({ theme }) => theme.mediab.l925`
    margin-left: 12px;
    margin-top: 5px;
  `}
`;

interface Props {
  item: any;
  selected: boolean;
  zasielkovna_id?: string;
  handleOptionClick: (option: any) => void;
}

function OptionChooserItem({ item, selected, handleOptionClick }: Props) {
  return (
    <>
      <Wrapper selected={selected} onClick={handleOptionClick}>
        <RowWrapper>
          <NamePriceWrapper>
            <CheckBox
              rounded={true}
              label={item.name}
              selected={selected}
              responsiveMarginBottom={0}
            />
            {(item.id === 'VUB' || item.id === 'CSOB') && (
              <ImagesContainer>
                <ImageContainer>
                  <Image
                    src={'/assets/dsi/payments/mastercard-logo.svg'}
                    alt="mastercard logo"
                    title="Mastercard"
                  />
                </ImageContainer>
                <ImageContainer>
                  <Image
                    src={'/assets/dsi/payments/visa.svg'}
                    alt="visa logo"
                    title="Visa"
                  />
                </ImageContainer>
              </ImagesContainer>
            )}

            {item.id === 'COMGATE_CARD' && (
              <ImagesContainer>
                <ImageContainer>
                  <Image
                    src={'/assets/dsi/payments/mastercard-logo.svg'}
                    alt="mastercard logo"
                    title="Mastercard"
                  />
                </ImageContainer>
                <ImageContainer>
                  <Image
                    src={'/assets/dsi/payments/visa.svg'}
                    alt="visa logo"
                    title="Visa"
                  />
                </ImageContainer>
                <ImageContainer>
                  <ComgateImage
                    src={'/assets/dsi/payments/apple-pay.svg'}
                    alt="applepay logo"
                    title="Apple pay"
                  />
                </ImageContainer>
                <ImageContainer>
                  <ComgateImage
                    // src={googlepay.toString()}
                    src={'/assets/dsi/payments/google-pay.svg'}
                    alt="googlepay logo"
                    title="Google pay"
                  />
                </ImageContainer>
              </ImagesContainer>
            )}

            {item.id === 'COMGATE_CUSTOM' && (
              <ImagesContainerComgateCustom>
                <ImageContainer>
                  <ComgateImage
                    src={'/assets/dsi/payments/cofidis.svg'}
                    alt="cofidis logo"
                    title="Cofidis"
                  />
                </ImageContainer>
                <ImageContainer>
                  <ComgateImage
                    src={'/assets/dsi/payments/skippay_mallpay.svg'}
                    alt="skippay logo"
                    title="Skip Pay"
                  />
                </ImageContainer>
                <ImageContainer>
                  <ComgateImage
                    src={'/assets/dsi/payments/twisto.svg'}
                    alt="twisto logo"
                    title="Twisto"
                  />
                </ImageContainer>
                <ImageContainer>
                  <ComgateImage
                    src={'/assets/dsi/payments/platim_pak.svg'}
                    alt="platim_pak logo"
                    title="PlatímPak"
                  />
                </ImageContainer>
              </ImagesContainerComgateCustom>
            )}
          </NamePriceWrapper>
          <PriceWrapper>
            <Price>{item.price}</Price>
          </PriceWrapper>
        </RowWrapper>

        {!!item.desc && <Desc> {item.desc} </Desc>}
      </Wrapper>
    </>
  );
}

export { OptionChooserItem as DsiOptionChooserItem };
